export const FORM_TEST = [
  {
    key: 'internalDropOff.date',
    type: 'frequency',
    defaultValue: '',
    props: {
      label: 'Priolist',
      required: true,
    },
  },
];

export const COMPLETE_FORM = JSON.parse(`
[
  {
    "type": "stepper",
    "fieldGroup": [
      {
        "props": {
          "label": "General Information"
        },
        "fieldGroup": [
          {
            "key": "animalSpecies",
            "type": "animal-species-autocomplete",
            "props": {
              "label": "Animal species",
              "required": true
            },
            "formSectionId": "637f64c429993afe912e31cd"
          },
          {
            "key": "priolist",
            "type": "input",
            "props": {
              "label": "Priolist",
              "type": "number",
              "required": true,
              "min": 0
            },
            "className": "form-field--admin",
            "formSectionId": "637f64c429993afe912e31cd"
          },
          {
            "key": "beltAndBatteryComments",
            "type": "textarea",
            "props": {
              "label": "Comments for belt and battery"
            },
            "className": "form-field--admin",
            "formSectionId": "637f64c429993afe912e31cd"
          },
          {
            "key": "collarImage",
            "type": "file",
            "props": {
              "label": "Upload collar image",
              "uploadUrl": ""
            },
            "className": "form-field--admin",
            "formSectionId": "637f64c429993afe912e31cd"
          },
          {
            "key": "customerName",
            "type": "input",
            "props": {
              "label": "Customer name"
            },
            "className": "form-field--admin",
            "formSectionId": "637f64c429993afe912e31cd"
          },
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "VHF Beacon Frequencies"
            },
            "fieldGroup": [
              {
                "key": "vhfBeaconFrequencies.option",
                "type": "radio",
                "props": {
                  "required": true,
                  "options": [
                    {
                      "value": "list",
                      "label": "VHF beacon frequencies (135 - 234 MHz)"
                    },
                    {
                      "value": "computed",
                      "label": "VHF beacon frequencies by start frequency, steps and number of collars"
                    }
                  ]
                }
              },
              {
                "key": "vhfBeaconFrequencies.frequencies",
                "type": "input",
                "defaultValue": "",
                "props": {
                  "type": "text",
                  "label": "Frequencies",
                  "suffixText": "MHz",
                  "placeholder": "VHF Frequencies in MHz (e.g. 150, 150.25)",
                  "required": true
                },
                "expressions": {
                  "hide": "model.vhfBeaconFrequencies?.option !== 'list'"
                }
              },
              {
                "key": "vhfBeaconFrequencies.startFrequency",
                "type": "input",
                "props": {
                  "type": "number",
                  "label": "Start frequency",
                  "required": true,
                  "min": 135,
                  "max": 234,
                  "step": 0.001,
                  "placeholder": "VHF Frequency in MHz (e.g. 150.000)",
                  "suffixText": "MHz"
                },
                "expressions": {
                  "hide": "model.vhfBeaconFrequencies?.option !== 'computed'"
                }
              },
              {
                "key": "vhfBeaconFrequencies.step",
                "type": "input",
                "props": {
                  "type": "number",
                  "label": "Steps",
                  "required": true,
                  "min": 0.001,
                  "max": 0.999,
                  "step": 0.001
                },
                "expressions": {
                  "hide": "model.vhfBeaconFrequencies?.option !== 'computed'"
                }
              }
            ],
            "formSectionId": "637f64c429993afe912e31cd"
          }
        ]
      },
      {
        "props": {
          "label": "Battery & Drop Off"
        },
        "fieldGroup": [
          {
            "type": "alert",
            "props": {
              "type": "info"
            },
            "expressions": {
              "props.label": "formState.batteryTypeLabel",
              "hide": "!formState.batteryTypeLabel"
            },
            "formSectionId": "637f64e529993afe912e31d0"
          },
          {
            "key": "batteryShape",
            "type": "select",
            "props": {
              "label": "Battery Shape - 1C",
              "options": [
                {
                  "value": "fixed",
                  "label": "fixed"
                },
                {
                  "value": "replaceable",
                  "label": "replaceable"
                }
              ]
            },
            "formSectionId": "637f64e529993afe912e31d0"
          },
          {
            "key": "batteryShape",
            "type": "select",
            "props": {
              "label": "Battery Shape - 3D, 4D, 5D",
              "options": [
                {
                  "value": "curved",
                  "label": "curved"
                },
                {
                  "value": "square",
                  "label": "square"
                }
              ]
            },
            "formSectionId": "637f64e529993afe912e31d0"
          },
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "Internal Drop Off (integrated in battery pack, max. 8 years lifetime after production)"
            },
            "fieldGroup": [
              {
                "key": "internalDropOff.mode",
                "type": "radio",
                "props": {
                  "options": [
                    {
                      "value": "relative",
                      "label": "Relative Release Time"
                    },
                    {
                      "value": "absolute",
                      "label": "Absolute Release Time (UTC)"
                    }
                  ],
                  "required": true
                }
              },
              {
                "wrappers": [
                  "group"
                ],
                "fieldGroup": [
                  {
                    "key": "internalDropOff.relativeTime",
                    "type": "relative-time",
                    "props": {
                      "maxDateRelative": "P416W",
                      "required": true
                    }
                  }
                ],
                "expressions": {
                  "hide": "model.internalDropOff?.mode !== 'relative'"
                }
              },
              {
                "wrappers": [
                  "group"
                ],
                "fieldGroup": [
                  {
                    "key": "internalDropOff.date",
                    "type": "datetime",
                    "props": {
                      "label": "Choose date",
                      "required": true,
                      "allowPastDates": false,
                      "maxDateRelative": "P416W"
                    }
                  }
                ],
                "expressions": {
                  "hide": "model.internalDropOff?.mode !== 'absolute'"
                }
              }
            ],
            "formSectionId": "637f64e529993afe912e31d0"
          },
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "External Drop Off (attached to the belt, max. 5 years lifetime after production)"
            },
            "fieldGroup": [
              {
                "key": "externalDropOff.mode",
                "type": "radio",
                "props": {
                  "options": [
                    {
                      "value": "relative",
                      "label": "Relative Release Time"
                    },
                    {
                      "value": "absolute",
                      "label": "Absolute Release Time (UTC)"
                    }
                  ],
                  "required": true
                }
              },
              {
                "wrappers": [
                  "group"
                ],
                "fieldGroup": [
                  {
                    "key": "externalDropOff.relativeTime",
                    "type": "relative-time",
                    "props": {
                      "maxDateRelative": "P260W",
                      "required": true
                    }
                  }
                ],
                "expressions": {
                  "hide": "model.externalDropOff?.mode !== 'relative'"
                }
              },
              {
                "wrappers": [
                  "group"
                ],
                "fieldGroup": [
                  {
                    "key": "externalDropOff.date",
                    "type": "datetime",
                    "props": {
                      "label": "Choose date",
                      "required": true,
                      "allowPastDates": false,
                      "maxDateRelative": "P260W"
                    }
                  }
                ],
                "expressions": {
                  "hide": "model.externalDropOff?.mode !== 'absolute'"
                }
              }
            ],
            "formSectionId": "637f64e529993afe912e31d0"
          }
        ]
      },
      {
        "props": {
          "label": "Belt Specification"
        },
        "fieldGroup": [
          {
            "key": "punch2",
            "type": "select",
            "props": {
              "label": "Punch. 2",
              "options": [
                {
                  "value": "m4",
                  "label": "M4"
                },
                {
                  "value": "m5",
                  "label": "M5"
                }
              ]
            },
            "className": "form-field--admin",
            "formSectionId": "641200b9f37669b68d0b1697"
          },
          {
            "key": "belt.protection",
            "type": "checkbox",
            "props": {
              "label": "Protection belt",
              "indeterminate": false
            },
            "className": "form-field--admin",
            "formSectionId": "641200b9f37669b68d0b1697"
          },
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "Standard specifications"
            },
            "fieldGroup": [
              {
                "key": "belt.length",
                "type": "input",
                "props": {
                  "type": "number",
                  "label": "Belt circumference in cm",
                  "min": 1,
                  "required": true
                }
              },
              {
                "key": "collarShape",
                "type": "select",
                "props": {
                  "required": true,
                  "label": "Collar shape",
                  "options": [
                    {
                      "value": "oval",
                      "label": "Oval"
                    },
                    {
                      "value": "round",
                      "label": "Round"
                    },
                    {
                      "value": "oval-round",
                      "label": "Oval-Round"
                    }
                  ]
                }
              },
              {
                "key": "collarShape",
                "type": "select",
                "props": {
                  "required": true,
                  "label": "Collar shape",
                  "options": [
                    {
                      "value": "drop-shaped",
                      "label": "Drop-shaped"
                    },
                    {
                      "value": "round",
                      "label": "Round"
                    }
                  ]
                }
              },
              {
                "key": "belt.thickness",
                "type": "select",
                "props": {
                  "label": "Belt thickness",
                  "options": [
                    {
                      "value": "st/st",
                      "label": "5.2 mm (ST/ST)"
                    },
                    {
                      "value": "sf/st",
                      "label": "4.3 mm (SF/ST)"
                    },
                    {
                      "value": "sf/sf",
                      "label": "3.3 mm (SF/SF)"
                    }
                  ]
                }
              },
              {
                "key": "belt.width",
                "type": "select",
                "props": {
                  "label": "Belt width",
                  "options": [
                    {
                      "value": "38mm",
                      "label": "38 mm"
                    },
                    {
                      "value": "50mm",
                      "label": "50 mm"
                    },
                    {
                      "value": "63mm",
                      "label": "63 mm"
                    },
                    {
                      "value": "75mm",
                      "label": "75 mm"
                    }
                  ]
                }
              },
              {
                "key": "belt.width",
                "type": "select",
                "defaultValue": "38mm",
                "props": {
                  "label": "Belt width",
                  "readonly": true,
                  "disabled": true,
                  "options": [
                    {
                      "value": "38mm",
                      "label": "38 mm"
                    }
                  ]
                }
              },
              {
                "key": "belt.width",
                "type": "select",
                "defaultValue": "50mm",
                "props": {
                  "label": "Belt width",
                  "readonly": true,
                  "disabled": true,
                  "options": [
                    {
                      "value": "50mm",
                      "label": "50mm"
                    }
                  ]
                }
              },
              {
                "key": "belt.width",
                "type": "select",
                "props": {
                  "label": "Belt width",
                  "options": [
                    {
                      "value": "32mm",
                      "label": "32 mm"
                    },
                    {
                      "value": "38mm",
                      "label": "38 mm"
                    },
                    {
                      "value": "50mm",
                      "label": "50 mm"
                    },
                    {
                      "value": "63mm",
                      "label": "63 mm"
                    },
                    {
                      "value": "75mm",
                      "label": "75 mm"
                    }
                  ]
                }
              },
              {
                "key": "belt.edges",
                "type": "select",
                "props": {
                  "label": "Belt edges",
                  "options": [
                    {
                      "value": "rounded",
                      "label": "Rounded"
                    },
                    {
                      "value": "smooth",
                      "label": "Smooth"
                    }
                  ]
                }
              }
            ],
            "formSectionId": "641200b9f37669b68d0b1697"
          },
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "Belt color"
            },
            "fieldGroup": [
              {
                "key": "belt.color",
                "type": "input",
                "defaultValue": "black",
                "props": {
                  "label": "Belt color (colors other than black at extra cost)",
                  "required": true
                }
              },
              {
                "key": "belt.colorDE",
                "type": "input",
                "props": {
                  "label": "Belt color in German"
                },
                "className": "form-field--admin"
              }
            ],
            "formSectionId": "641200b9f37669b68d0b1697"
          },
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "Additional features at extra cost"
            },
            "fieldGroup": [
              {
                "key": "belt.reflectiveCharactersIncluded",
                "type": "checkbox",
                "props": {
                  "label": "Colored letters on belt",
                  "indeterminate": false
                }
              },
              {
                "key": "belt.reflectiveCharacters",
                "type": "textarea",
                "props": {
                  "label": "max. 3 letters per collar",
                  "rows": 4,
                  "required": true
                },
                "expressions": {
                  "hide": "!model.belt?.reflectiveCharactersIncluded"
                }
              },
              {
                "key": "belt.reflectiveStripe",
                "type": "checkbox",
                "props": {
                  "label": "Reflective Stripe On Belt",
                  "indeterminate": false
                }
              },
              {
                "key": "plateLabel",
                "type": "checkbox",
                "props": {
                  "label": "Stainless Steel Label Plate",
                  "indeterminate": false
                }
              },
              {
                "key": "plateLabelValue",
                "type": "textarea",
                "props": {
                  "label": "max. 4 lines laser inscribed",
                  "rows": 4,
                  "required": true
                },
                "expressions": {
                  "hide": "!model.plateLabel"
                }
              },
              {
                "key": "housingLabel",
                "type": "checkbox",
                "props": {
                  "label": "Laser inscribed label on housing",
                  "indeterminate": false
                }
              },
              {
                "key": "housingLabelValue",
                "type": "textarea",
                "props": {
                  "label": "Label that should be inscribed",
                  "rows": 4,
                  "required": true
                },
                "expressions": {
                  "hide": "!model.housingLabel"
                }
              },
              {
                "key": "cottonBreakAway.included",
                "type": "checkbox",
                "props": {
                  "label": "Cotton Belt Break Away",
                  "indeterminate": false
                }
              },
              {
                "key": "cottonBreakAway.layers",
                "type": "select",
                "props": {
                  "label": "Number of layers",
                  "options": [
                    {
                      "value": 1,
                      "label": "1-layer"
                    },
                    {
                      "value": 2,
                      "label": "2-layer"
                    },
                    {
                      "value": 3,
                      "label": "3-layer"
                    },
                    {
                      "value": 4,
                      "label": "4-layer"
                    },
                    {
                      "value": 5,
                      "label": "5-layer"
                    },
                    {
                      "value": 6,
                      "label": "6-layer"
                    }
                  ],
                  "required": true
                },
                "expressions": {
                  "hide": "!model.cottonBreakAway?.included"
                }
              }
            ],
            "formSectionId": "641200b9f37669b68d0b1697"
          },
          {
            "key": "belt.elasticExpandableOption",
            "type": "radio",
            "props": {
              "label": "Elastic/Expandable Belt Options",
              "options": [
                {
                  "value": "elastic with teflon",
                  "label": "Elastic option with Teflon"
                },
                {
                  "value": "elastic-expandable",
                  "label": "Elastic-expandable"
                },
                {
                  "value": "expandable belt",
                  "label": "Expandable belt"
                },
                {
                  "value": "expandable belt custom",
                  "label": "Expandable belt custom"
                },
                {
                  "value": "elastic with plastic belt",
                  "label": "Elastic with plastic belt"
                },
                {
                  "value": "other",
                  "label": "Other"
                }
              ]
            },
            "formSectionId": "641200b9f37669b68d0b1697"
          },
          {
            "key": "belt.expandableSize",
            "type": "select",
            "props": {
              "label": "Expandable Belt Size",
              "options": [
                {
                  "value": "22cm-34cm",
                  "label": "From 22cm to 34cm"
                },
                {
                  "value": "24cm-40cm",
                  "label": "From 24cm to 40cm"
                }
              ],
              "required": true
            },
            "expressions": {
              "hide": "model.belt?.elasticExpandableOption !== 'expandable belt'"
            },
            "formSectionId": "641200b9f37669b68d0b1697"
          },
          {
            "key": "belt.expandableCustomSize.from",
            "type": "input",
            "props": {
              "label": "From",
              "type": "number",
              "min": 1,
              "max": 100,
              "required": true
            },
            "expressions": {
              "hide": "model.belt?.elasticExpandableOption !== 'expandable belt custom'"
            },
            "formSectionId": "641200b9f37669b68d0b1697"
          },
          {
            "key": "belt.expandableCustomSize.to",
            "type": "input",
            "props": {
              "label": "To",
              "type": "number",
              "min": 1,
              "max": 100,
              "required": true
            },
            "expressions": {
              "hide": "model.belt?.elasticExpandableOption !== 'expandable belt custom'"
            },
            "formSectionId": "641200b9f37669b68d0b1697"
          },
          {
            "key": "belt.otherRequest",
            "type": "textarea",
            "props": {
              "label": "Please specify your request",
              "rows": 4,
              "required": true
            },
            "expressions": {
              "hide": "model.belt?.elasticExpandableOption !== 'other'"
            },
            "formSectionId": "641200b9f37669b68d0b1697"
          }
        ]
      },
      {
        "props": {
          "label": "Communication"
        },
        "fieldGroup": [
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "Iridium"
            },
            "fieldGroup": [
              {
                "key": "iridium.plan",
                "type": "select",
                "props": {
                  "label": "Plan for your Airtime Fees",
                  "required": true,
                  "options": [
                    {
                      "value": "3kByte",
                      "label": "3kByte plan"
                    },
                    {
                      "value": "unlimited",
                      "label": "Unlimited plan"
                    }
                  ]
                }
              },
              {
                "key": "iridium.mode",
                "type": "select",
                "defaultValue": 4,
                "props": {
                  "label": "Mode",
                  "required": true,
                  "options": [
                    {
                      "value": 1,
                      "label": "1 fix per message"
                    },
                    {
                      "value": 2,
                      "label": "2 fixes per message"
                    },
                    {
                      "value": 3,
                      "label": "3 fixes per message"
                    },
                    {
                      "value": 4,
                      "label": "4 fixes per message"
                    },
                    {
                      "value": 5,
                      "label": "5 fixes per message"
                    },
                    {
                      "value": 6,
                      "label": "6 fixes per message"
                    },
                    {
                      "value": 7,
                      "label": "7 fixes per message"
                    },
                    {
                      "value": 8,
                      "label": "8 fixes per message"
                    },
                    {
                      "value": 9,
                      "label": "9 fixes per message"
                    },
                    {
                      "value": 10,
                      "label": "10 fixes per message"
                    },
                    {
                      "value": 11,
                      "label": "11 fixes per message"
                    },
                    {
                      "value": 12,
                      "label": "12 fixes per message"
                    },
                    {
                      "value": 13,
                      "label": "13 fixes per message"
                    },
                    {
                      "value": 14,
                      "label": "14 fixes per message"
                    },
                    {
                      "value": 15,
                      "label": "15 fixes per message"
                    },
                    {
                      "value": 16,
                      "label": "16 fixes per message"
                    },
                    {
                      "value": 17,
                      "label": "17 fixes per message"
                    },
                    {
                      "value": 18,
                      "label": "18 fixes per message"
                    }
                  ]
                }
              }
            ],
            "formSectionId": "641200eff37669b68d0b1699"
          },
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "Globalstar"
            },
            "fieldGroup": [
              {
                "key": "globalstar.mode",
                "type": "select",
                "defaultValue": 1,
                "props": {
                  "label": "Mode",
                  "required": true,
                  "disabled": true,
                  "options": [
                    {
                      "value": 1,
                      "label": "1 fix per message"
                    }
                  ]
                }
              }
            ],
            "formSectionId": "641200eff37669b68d0b1699"
          },
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "GSM (Please be sure SIM cards are activated, international roaming is enabled and there is credit on the account)"
            },
            "fieldGroup": [
              {
                "key": "gsm.mode",
                "type": "select",
                "defaultValue": 6,
                "props": {
                  "label": "Mode",
                  "required": true,
                  "options": [
                    {
                      "value": 1,
                      "label": "1 fix per message"
                    },
                    {
                      "value": 2,
                      "label": "2 fixes per message"
                    },
                    {
                      "value": 3,
                      "label": "3 fixes per message"
                    },
                    {
                      "value": 4,
                      "label": "4 fixes per message"
                    },
                    {
                      "value": 5,
                      "label": "5 fixes per message"
                    },
                    {
                      "value": 6,
                      "label": "6 fixes per message"
                    }
                  ]
                }
              },
              {
                "key": "gsm.destinationNumber",
                "type": "input",
                "props": {
                  "label": "Optional: Destination Number of your own GSM USB Ground Station",
                  "placeholder": "ex. +49 5876 8864"
                }
              }
            ],
            "formSectionId": "641200eff37669b68d0b1699"
          },
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "UHF Communication"
            },
            "fieldGroup": [
              {
                "key": "uhf.schedule",
                "type": "timerange",
                "defaultValue": "12:00-12:15",
                "props": {
                  "label": "Time window",
                  "startBeforeEnd": true
                }
              }
            ],
            "formSectionId": "641200eff37669b68d0b1699"
          }
        ]
      },
      {
        "props": {
          "label": "Programming"
        },
        "fieldGroup": [
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "Acceleration sensor (activity)"
            },
            "fieldGroup": [
              {
                "key": "advancedSensorPackage",
                "type": "checkbox",
                "props": {
                  "label": "Advanced 3-axis (Hz + G)",
                  "indeterminate": false
                }
              },
              {
                "wrappers": [
                  "group"
                ],
                "fieldGroup": [
                  {
                    "key": "acceleration.sampleRate",
                    "type": "select",
                    "defaultValue": "8Hz",
                    "props": {
                      "label": "Acceleration recording sample rate",
                      "required": true,
                      "options": [
                        {
                          "value": "2Hz",
                          "label": "2 Hz"
                        },
                        {
                          "value": "4Hz",
                          "label": "4 Hz"
                        },
                        {
                          "value": "8Hz",
                          "label": "8 Hz"
                        },
                        {
                          "value": "16Hz",
                          "label": "16 Hz"
                        },
                        {
                          "value": "32Hz",
                          "label": "32 Hz"
                        }
                      ]
                    }
                  },
                  {
                    "key": "acceleration.sensorRange",
                    "type": "select",
                    "defaultValue": "4G",
                    "props": {
                      "label": "Acceleration sensor range",
                      "required": true,
                      "options": [
                        {
                          "value": "2G",
                          "label": "±2G"
                        },
                        {
                          "value": "4G",
                          "label": "±4G"
                        },
                        {
                          "value": "8G",
                          "label": "±8G"
                        }
                      ]
                    }
                  }
                ],
                "expressions": {
                  "hide": "!model.advancedSensorPackage"
                }
              }
            ],
            "formSectionId": "641200f9f37669b68d0b169b"
          },
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "Temperature sensor"
            },
            "fieldGroup": [
              {
                "key": "temperatureSensor.enabled",
                "type": "checkbox",
                "defaultValue": true,
                "props": {
                  "label": "enabled",
                  "indeterminate": false
                },
                "className": "form-field--admin"
              }
            ],
            "formSectionId": "641200f9f37669b68d0b169b"
          },
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "Mortality sensor"
            },
            "fieldGroup": [
              {
                "key": "mortalitySensor.enabled",
                "type": "checkbox",
                "defaultValue": true,
                "props": {
                  "label": "enabled",
                  "indeterminate": false
                },
                "className": "form-field--admin"
              },
              {
                "key": "mortalitySensor.period",
                "type": "input",
                "defaultValue": 24,
                "props": {
                  "type": "number",
                  "label": "Mortality period in hours",
                  "required": true
                }
              }
            ],
            "formSectionId": "641200f9f37669b68d0b169b"
          },
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "UTC correction for schedules"
            },
            "fieldGroup": [
              {
                "key": "utcCorrection.mode",
                "type": "radio",
                "defaultValue": "utc",
                "props": {
                  "options": [
                    {
                      "value": "utc",
                      "label": "UTC"
                    },
                    {
                      "value": "lmt",
                      "label": "LMT"
                    }
                  ],
                  "required": true
                }
              },
              {
                "key": "utcCorrection.timezone",
                "type": "select",
                "props": {
                  "label": "Timezone",
                  "required": true,
                  "options": [
                    {
                      "value": "gmt-12:00",
                      "label": "GMT-12:00"
                    },
                    {
                      "value": "gmt-11:00",
                      "label": "GMT-11:00"
                    },
                    {
                      "value": "gmt-10:00",
                      "label": "GMT-10:00"
                    },
                    {
                      "value": "gmt-09:00",
                      "label": "GMT-09:00"
                    },
                    {
                      "value": "gmt-08:00",
                      "label": "GMT-08:00"
                    },
                    {
                      "value": "gmt-07:00",
                      "label": "GMT-07:00"
                    },
                    {
                      "value": "gmt-06:00",
                      "label": "GMT-06:00"
                    },
                    {
                      "value": "gmt-05:00",
                      "label": "GMT-05:00"
                    },
                    {
                      "value": "gmt-04:00",
                      "label": "GMT-04:00"
                    },
                    {
                      "value": "gmt-03:00",
                      "label": "GMT-03:00"
                    },
                    {
                      "value": "gmt-02:00",
                      "label": "GMT-02:00"
                    },
                    {
                      "value": "gmt-01:00",
                      "label": "GMT-01:00"
                    },
                    {
                      "value": "gmt+00:00",
                      "label": "GMT+00:00"
                    },
                    {
                      "value": "gmt+01:00",
                      "label": "GMT+01:00"
                    },
                    {
                      "value": "gmt+02:00",
                      "label": "GMT+02:00"
                    },
                    {
                      "value": "gmt+03:00",
                      "label": "GMT+03:00"
                    },
                    {
                      "value": "gmt+04:00",
                      "label": "GMT+04:00"
                    },
                    {
                      "value": "gmt+05:00",
                      "label": "GMT+05:00"
                    },
                    {
                      "value": "gmt+06:00",
                      "label": "GMT+06:00"
                    },
                    {
                      "value": "gmt+07:00",
                      "label": "GMT+07:00"
                    },
                    {
                      "value": "gmt+08:00",
                      "label": "GMT+08:00"
                    },
                    {
                      "value": "gmt+09:00",
                      "label": "GMT+09:00"
                    },
                    {
                      "value": "gmt+10:00",
                      "label": "GMT+10:00"
                    },
                    {
                      "value": "gmt+11:00",
                      "label": "GMT+11:00"
                    },
                    {
                      "value": "gmt+12:00",
                      "label": "GMT+12:00"
                    },
                    {
                      "value": "gmt+13:00",
                      "label": "GMT+13:00"
                    }
                  ]
                },
                "expressions": {
                  "hide": "model.utcCorrection?.mode !== 'lmt'"
                }
              }
            ],
            "formSectionId": "641200f9f37669b68d0b169b"
          },
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "External sensors"
            },
            "fieldGroup": [
              {
                "wrappers": [
                  "group"
                ],
                "props": {
                  "label": "Proximity sensor reception"
                },
                "fieldGroup": [
                  {
                    "key": "proximitySensor.enabled",
                    "type": "checkbox",
                    "props": {
                      "label": "enabled",
                      "indeterminate": false
                    }
                  },
                  {
                    "wrappers": [
                      "group"
                    ],
                    "fieldGroup": [
                      {
                        "key": "proximitySensor.customSettings",
                        "type": "checkbox",
                        "props": {
                          "label": "Custom configuration",
                          "indeterminate": false
                        }
                      },
                      {
                        "wrappers": [
                          "group"
                        ],
                        "fieldGroup": [
                          {
                            "key": "proximitySensor.eventCanChangeGpsSchedule",
                            "type": "radio",
                            "props": {
                              "label": "Choose if in the Case of a Proximity Event the GPS Schedule should change",
                              "options": [
                                {
                                  "value": false,
                                  "label": "No"
                                },
                                {
                                  "value": true,
                                  "label": "Yes"
                                }
                              ],
                              "required": true
                            }
                          },
                          {
                            "wrappers": [
                              "group"
                            ],
                            "fieldGroup": [
                              {
                                "key": "proximitySensor.scheduleFile",
                                "type": "file",
                                "props": {
                                  "label": "Upload schedule file",
                                  "uploadUrl": "",
                                  "required": true
                                }
                              },
                              {
                                "key": "proximitySensor.scheduleFileContent",
                                "type": "textarea",
                                "props": {
                                  "label": "Proximity schedule file content",
                                  "rows": 4
                                },
                                "className": "form-field--admin"
                              },
                              {
                                "key": "proximitySensor.skipGpsProximitiesCount",
                                "type": "input",
                                "props": {
                                  "type": "number",
                                  "label": "Define skip count for proximity GPS schedule",
                                  "required": true
                                }
                              },
                              {
                                "key": "proximitySensor.activeDuration",
                                "type": "input",
                                "props": {
                                  "label": "Define „active duration“ of proximity GPS schedule",
                                  "required": true
                                }
                              },
                              {
                                "key": "proximitySensor.elapseTime",
                                "type": "input",
                                "props": {
                                  "label": "Define „elapse time“ of proximity GPS schedule",
                                  "required": true
                                }
                              }
                            ],
                            "expressions": {
                              "hide": "!model.proximitySensor?.eventCanChangeGpsSchedule"
                            }
                          },
                          {
                            "key": "proximitySensor.onlyParticularCollarsCanTriggerEvent",
                            "type": "radio",
                            "props": {
                              "label": "Choose if only particauler Collars can trigger a Proximity Event",
                              "options": [
                                {
                                  "value": false,
                                  "label": "No"
                                },
                                {
                                  "value": true,
                                  "label": "yes"
                                }
                              ],
                              "required": true
                            }
                          },
                          {
                            "wrappers": [
                              "group"
                            ],
                            "fieldGroup": [
                              {
                                "key": "proximitySensor.whiteList",
                                "type": "textarea",
                                "props": {
                                  "label": "Define white list",
                                  "rows": 4,
                                  "required": true
                                }
                              },
                              {
                                "key": "proximitySensor.blackList",
                                "type": "textarea",
                                "props": {
                                  "label": "Define black list",
                                  "rows": 4,
                                  "required": true
                                }
                              },
                              {
                                "key": "proximitySensor.includeCollarOfExistingOrder",
                                "type": "radio",
                                "props": {
                                  "label": "Include collar IDs of existing order",
                                  "options": [
                                    {
                                      "value": false,
                                      "label": "No"
                                    },
                                    {
                                      "value": true,
                                      "label": "Yes"
                                    }
                                  ],
                                  "required": true
                                }
                              },
                              {
                                "wrappers": [
                                  "group"
                                ],
                                "fieldGroup": [
                                  {
                                    "key": "proximitySensor.collarIds",
                                    "type": "textarea",
                                    "props": {
                                      "label": "Collar IDs of existing order",
                                      "rows": 4,
                                      "required": true
                                    }
                                  }
                                ],
                                "expressions": {
                                  "hide": "!model.proximitySensor?.includeCollarOfExistingOrder"
                                }
                              }
                            ],
                            "expressions": {
                              "hide": "!model.proximitySensor?.onlyParticularCollarsCanTriggerEvent"
                            }
                          }
                        ],
                        "expressions": {
                          "hide": "!model.proximitySensor?.customSettings"
                        }
                      }
                    ],
                    "expressions": {
                      "hide": "!model.proximitySensor?.enabled"
                    }
                  }
                ]
              },
              {
                "wrappers": [
                  "group"
                ],
                "props": {
                  "label": "Separation sensor reception"
                },
                "fieldGroup": [
                  {
                    "key": "separationSensor.enabled",
                    "type": "checkbox",
                    "props": {
                      "label": "enabled",
                      "indeterminate": false
                    }
                  },
                  {
                    "wrappers": [
                      "group"
                    ],
                    "fieldGroup": [
                      {
                        "key": "separationSensor.customSettings",
                        "type": "checkbox",
                        "props": {
                          "label": "Custom configuration",
                          "indeterminate": false
                        }
                      },
                      {
                        "wrappers": [
                          "group"
                        ],
                        "fieldGroup": [
                          {
                            "key": "separationSensor.noContactDelay",
                            "type": "input",
                            "props": {
                              "label": "Define 'no contact delay'",
                              "required": true
                            }
                          },
                          {
                            "key": "separationSensor.alarmMessage",
                            "type": "radio",
                            "props": {
                              "label": "Alarm Message in case of Separation Event",
                              "options": [
                                {
                                  "value": false,
                                  "label": "No"
                                },
                                {
                                  "value": true,
                                  "label": "Yes"
                                }
                              ],
                              "required": true
                            }
                          },
                          {
                            "wrappers": [
                              "group"
                            ],
                            "props": {
                              "label": "Define which collar IDs will trigger a separation event"
                            },
                            "fieldGroup": [
                              {
                                "key": "separationSensor.ids",
                                "type": "textarea",
                                "props": {
                                  "label": "ID list",
                                  "rows": 4,
                                  "required": true
                                }
                              },
                              {
                                "key": "separationSensor.includeIdsOfExistingOrder",
                                "type": "radio",
                                "props": {
                                  "label": "Include collar IDs of existing order",
                                  "options": [
                                    {
                                      "value": false,
                                      "label": "No"
                                    },
                                    {
                                      "value": true,
                                      "label": "yes"
                                    }
                                  ],
                                  "required": true
                                }
                              },
                              {
                                "wrappers": [
                                  "group"
                                ],
                                "fieldGroup": [
                                  {
                                    "key": "separationSensor.collarIds",
                                    "type": "input",
                                    "props": {
                                      "label": "Collar IDs of existing order",
                                      "required": true
                                    }
                                  }
                                ],
                                "expressions": {
                                  "hide": "!model.separationSensor?.includeIdsOfExistingOrder"
                                }
                              }
                            ]
                          }
                        ],
                        "expressions": {
                          "hide": "!model.separationSensor?.customSettings"
                        }
                      }
                    ],
                    "expressions": {
                      "hide": "!model.separationSensor?.enabled"
                    }
                  }
                ]
              },
              {
                "wrappers": [
                  "group"
                ],
                "props": {
                  "label": "Mortality implant sensor (MIT) reception"
                },
                "fieldGroup": [
                  {
                    "key": "mitSensor.enabled",
                    "type": "checkbox",
                    "props": {
                      "label": "enabled",
                      "indeterminate": false
                    }
                  },
                  {
                    "wrappers": [
                      "group"
                    ],
                    "fieldGroup": [
                      {
                        "type": "alert",
                        "props": {
                          "label": "Alarm Message in case of MIT Event: Yes",
                          "type": "info"
                        }
                      },
                      {
                        "wrappers": [
                          "group"
                        ],
                        "props": {
                          "label": "Define if pairing with existing MITs or with a new order is requested"
                        },
                        "fieldGroup": [
                          {
                            "key": "mitSensor.ids",
                            "type": "textarea",
                            "props": {
                              "label": "ID list",
                              "rows": 4
                            }
                          },
                          {
                            "key": "mitSensor.includeIdsOfExistingOrder",
                            "type": "radio",
                            "props": {
                              "label": "Include collar IDs of existing order",
                              "options": [
                                {
                                  "value": false,
                                  "label": "No"
                                },
                                {
                                  "value": true,
                                  "label": "yes"
                                }
                              ]
                            }
                          },
                          {
                            "wrappers": [
                              "group"
                            ],
                            "fieldGroup": [
                              {
                                "key": "mitSensor.collarIds",
                                "type": "input",
                                "props": {
                                  "label": "Collar IDs of existing order",
                                  "required": true
                                }
                              }
                            ],
                            "expressions": {
                              "hide": "!model.mitSensor?.includeIdsOfExistingOrder"
                            }
                          }
                        ]
                      }
                    ],
                    "expressions": {
                      "hide": "!model.mitSensor?.enabled"
                    }
                  }
                ]
              },
              {
                "wrappers": [
                  "group"
                ],
                "props": {
                  "label": "Vaginal implant sensor (VIT) reception"
                },
                "fieldGroup": [
                  {
                    "key": "vitSensor.enabled",
                    "type": "checkbox",
                    "props": {
                      "label": "enabled",
                      "indeterminate": false
                    }
                  },
                  {
                    "wrappers": [
                      "group"
                    ],
                    "fieldGroup": [
                      {
                        "type": "alert",
                        "props": {
                          "label": "Alarm Message in case of VIT Event: Yes",
                          "type": "info"
                        }
                      },
                      {
                        "wrappers": [
                          "group"
                        ],
                        "props": {
                          "label": "Define if pairing with existing VITs or with a new order is requested"
                        },
                        "fieldGroup": [
                          {
                            "key": "vitSensor.ids",
                            "type": "textarea",
                            "props": {
                              "label": "ID list",
                              "rows": 4
                            }
                          },
                          {
                            "key": "vitSensor.includeIdsOfExistingOrder",
                            "type": "radio",
                            "props": {
                              "label": "Include collar IDs of existing order",
                              "options": [
                                {
                                  "value": false,
                                  "label": "No"
                                },
                                {
                                  "value": true,
                                  "label": "yes"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    ],
                    "expressions": {
                      "hide": "!model.vitSensor?.enabled"
                    }
                  }
                ]
              }
            ],
            "formSectionId": "641200f9f37669b68d0b169b"
          },
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "Collar schedule programming"
            },
            "fieldGroup": [
              {
                "wrappers": [
                  "group"
                ],
                "props": {
                  "label": "GPS schedule"
                },
                "fieldGroup": [
                  {
                    "key": "gpsSchedule.desc",
                    "type": "input",
                    "props": {
                      "label": "GPS schedule (ex. every hour)",
                      "required": true
                    }
                  },
                  {
                    "key": "gpsSchedule.file",
                    "type": "file",
                    "props": {
                      "label": "Upload GPS schedule file",
                      "uploadUrl": ""
                    },
                    "className": "form-field--admin"
                  },
                  {
                    "key": "gpsSchedule.fileContent",
                    "type": "input",
                    "props": {
                      "label": "GPS schedule content"
                    },
                    "className": "form-field--admin"
                  }
                ]
              },
              {
                "wrappers": [
                  "group"
                ],
                "props": {
                  "label": "VHF schedule"
                },
                "fieldGroup": [
                  {
                    "key": "vhfSchedule.desc",
                    "type": "timerange",
                    "props": {
                      "label": "Time range",
                      "required": true,
                      "startBeforeEnd": false
                    }
                  },
                  {
                    "key": "vhfSchedule.file",
                    "type": "file",
                    "props": {
                      "label": "Upload VHF schedule file",
                      "uploadUrl": ""
                    },
                    "className": "form-field--admin"
                  },
                  {
                    "key": "vhfSchedule.fileContent",
                    "type": "input",
                    "props": {
                      "label": "VHF schedule file content"
                    },
                    "className": "form-field--admin"
                  }
                ]
              },
              {
                "key": "skipGpsLocations.enabled",
                "type": "checkbox",
                "props": {
                  "label": "GPS Skip Count",
                  "indeterminate": false
                }
              },
              {
                "key": "skipGpsLocations.count",
                "type": "input",
                "props": {
                  "label": "GPS location skip count (ex. skip count 2 - sends every 3rd GPS location)",
                  "type": "number",
                  "required": true
                },
                "expressions": {
                  "hide": "!model.skipGpsLocations?.enabled"
                }
              }
            ],
            "formSectionId": "641200f9f37669b68d0b169b"
          },
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "Notification settings"
            },
            "fieldGroup": [
              {
                "type": "alert",
                "props": {
                  "type": "warning",
                  "label": "If you don't specify your notification preferences, you won't receive any notifications"
                }
              },
              {
                "key": "notifications.email",
                "type": "repeat",
                "defaultValue": [],
                "props": {
                  "addText": "Add e-mail address",
                  "label": "E-Mail addresses for notifications"
                },
                "fieldArray": {
                  "type": "input",
                  "props": {
                    "label": "E-mail address"
                  }
                }
              },
              {
                "key": "notifications.phone",
                "type": "repeat",
                "defaultValue": [],
                "props": {
                  "label": "Phone numbers for notifications",
                  "addText": "Add phone number"
                },
                "fieldArray": {
                  "type": "input",
                  "props": {
                    "label": "Phone number"
                  }
                }
              }
            ],
            "formSectionId": "641200f9f37669b68d0b169b"
          },
          {
            "key": "communicationSchedule.enabled",
            "type": "checkbox",
            "props": {
              "label": "Communication schedule",
              "indeterminate": false
            },
            "formSectionId": "641200f9f37669b68d0b169b"
          },
          {
            "key": "communicationSchedule.time",
            "type": "input",
            "props": {
              "label": "GSM/IRIDIUM scheduled transmission time (e.g. daily transmission at 11:00 am)",
              "required": true
            },
            "expressions": {
              "hide": "!model.communicationSchedule?.enabled"
            },
            "formSectionId": "641200f9f37669b68d0b169b"
          },
          {
            "key": "idTag",
            "type": "checkbox",
            "props": {
              "label": "UHF ID Tag option (at extra charge)",
              "indeterminate": false
            },
            "formSectionId": "641200f9f37669b68d0b169b"
          },
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "Camera option"
            },
            "fieldGroup": [
              {
                "key": "camera.lensOrientation",
                "type": "select",
                "props": {
                  "label": "Define orientation",
                  "options": [
                    {
                      "value": "front",
                      "label": "Front"
                    },
                    {
                      "value": "front extended",
                      "label": "Front Extended"
                    },
                    {
                      "value": "side",
                      "label": "Side"
                    }
                  ],
                  "required": true
                }
              },
              {
                "key": "camera.schedule",
                "type": "textarea",
                "props": {
                  "label": "Define camera schedule",
                  "rows": 2,
                  "required": true
                }
              },
              {
                "key": "camera.videoTrigger",
                "type": "select",
                "props": {
                  "label": "Trigger for video",
                  "options": [
                    {
                      "value": "gps",
                      "label": "GPS"
                    },
                    {
                      "value": "timer",
                      "label": "Timer"
                    }
                  ],
                  "required": true
                }
              },
              {
                "key": "camera.utcCorrection",
                "type": "textarea",
                "props": {
                  "label": "UTC Correction for camera schedule",
                  "rows": 2,
                  "required": true
                }
              },
              {
                "key": "camera.mode",
                "type": "radio",
                "props": {
                  "label": "Camera mode",
                  "options": [
                    {
                      "value": "video",
                      "label": "Video"
                    },
                    {
                      "value": "photo",
                      "label": "Photo"
                    },
                    {
                      "value": "video and photo",
                      "label": "Video and Photo"
                    }
                  ],
                  "required": true
                }
              },
              {
                "key": "camera.videoSettings",
                "type": "select",
                "props": {
                  "label": "Video settings",
                  "options": [
                    {
                      "value": "Long Runtime: 1280x720, 30fps, wide FOV",
                      "label": "Long Runtime: 1280x720, 30fps, wide FOV"
                    },
                    {
                      "value": "High Framerate: 1280x720, 120fps, wide FOV",
                      "label": "High Framerate: 1280x720, 120fps, wide FOV (90% runtime compared to Long Runtime option)"
                    },
                    {
                      "value": "High Resolution: 3840x2160, 30fps, wide FOV",
                      "label": "High Resolution: 3840x2160, 30fps, wide FOV (50% runtime compared to Long Runtime option)"
                    }
                  ],
                  "required": true
                },
                "expressions": {
                  "hide": "model.camera?.mode == null || model.camera?.mode === 'photo'"
                }
              },
              {
                "key": "camera.videoLength",
                "type": "input",
                "props": {
                  "label": "Video length",
                  "required": true
                },
                "expressions": {
                  "hide": "model.camera?.mode == null || model.camera?.mode === 'photo' || model.camera?.mode === 'video and photo'"
                }
              },
              {
                "key": "camera.photoFormat",
                "type": "select",
                "props": {
                  "label": "Photo format",
                  "options": [
                    {
                      "value": "wide",
                      "label": "Wide"
                    },
                    {
                      "value": "linear",
                      "label": "Linear"
                    }
                  ],
                  "required": true
                },
                "expressions": {
                  "hide": "model.camera?.mode == null || model.camera?.mode === 'video'"
                }
              }
            ],
            "formSectionId": "641200f9f37669b68d0b169b"
          },
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "Virtual Fence"
            },
            "fieldGroup": [
              {
                "key": "virtualFence.enabled",
                "type": "checkbox",
                "props": {
                  "label": "enabled",
                  "indeterminate": false
                }
              },
              {
                "key": "fence.kml",
                "type": "file",
                "props": {
                  "label": "Upload KML file",
                  "uploadUrl": "",
                  "required": true
                },
                "expressions": {
                  "hide": "!model.virtualFence?.enabled"
                }
              },
              {
                "key": "virtualFence.mode",
                "type": "select",
                "props": {
                  "label": "Virtual Fence Mode",
                  "options": [
                    {
                      "value": "no message",
                      "label": "No message"
                    },
                    {
                      "value": "message on enter",
                      "label": "Message on enter"
                    },
                    {
                      "value": "message on leave",
                      "label": "Message on leave"
                    },
                    {
                      "value": "message on enter and leave",
                      "label": "Message on enter and leave"
                    }
                  ],
                  "required": true
                },
                "expressions": {
                  "hide": "!model.virtualFence?.enabled"
                }
              },
              {
                "key": "virtualFence.schedule",
                "type": "input",
                "props": {
                  "label": "Virtual fence schedule",
                  "required": true
                },
                "expressions": {
                  "hide": "!model.virtualFence?.enabled"
                }
              },
              {
                "key": "fence.schedule",
                "type": "file",
                "props": {
                  "label": "Upload fence schedule file",
                  "uploadUrl": "",
                  "required": true
                },
                "expressions": {
                  "hide": "!model.virtualFence?.enabled"
                }
              }
            ],
            "formSectionId": "641200f9f37669b68d0b169b"
          },
          {
            "wrappers": [
              "group"
            ],
            "props": {
              "label": "Hibernation sensor"
            },
            "fieldGroup": [
              {
                "key": "hibernationSensor.enabled",
                "type": "checkbox",
                "props": {
                  "label": "enabled",
                  "indeterminate": false
                }
              },
              {
                "key": "hibernationSensor.period",
                "type": "input",
                "defaultValue": "24h",
                "props": {
                  "label": "Hibernation period",
                  "required": true
                },
                "expressions": {
                  "hide": "!model.hibernationSensor?.enabled"
                }
              },
              {
                "key": "hibernationSensor.wakeupLevel",
                "type": "slider",
                "defaultValue": 39,
                "props": {
                  "label": "Hibernation Wakeup Level",
                  "thumbLabel": true,
                  "min": 0,
                  "max": 254
                },
                "className": "form-field--admin",
                "expressions": {
                  "hide": "!model.hibernationSensor?.enabled"
                }
              }
            ],
            "formSectionId": "641200f9f37669b68d0b169b"
          },
          {
            "key": "configurationComments",
            "type": "textarea",
            "props": {
              "label": "Comments for configuration",
              "rows": 4
            },
            "className": "form-field--admin",
            "formSectionId": "641200f9f37669b68d0b169b"
          }
        ]
      },
      {
        "props": {
          "label": "Additional information"
        },
        "fieldGroup": [
          {
            "key": "specialRequest",
            "type": "textarea",
            "props": {
              "label": "Do you have any special requests regarding this configuration?",
              "rows": 4
            },
            "formSectionId": "6412010df37669b68d0b169d"
          }
        ]
      }
    ]
  }
]
`);
